/**
 * Enum representing horizontal positions for 'justify-content' CSS property.
 */
export enum HorizontalPosition {
    START = 'start',
    CENTER = 'center',
    END = 'end',
}
